module.exports = __webpack_public_path__ + "img/127.b46583e9.png";